// extracted by mini-css-extract-plugin
module.exports = {"cls1":"about-Content-module--cls1--1GsbW","cls2":"about-Content-module--cls2--UbT3g about-Content-module--cls1--1GsbW"};